import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ConsultationModal from '../components/ConsultationModal';
import TopBar from '../components/TopBar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';


const services = [
  { icon: 'fa-building-columns', label: 'Company Registration' },
  { icon: 'fa-trademark',        label: 'Trademark Registration' },
  { icon: 'fa-file-invoice-dollar', label: 'GST Registration' },
  { icon: 'fa-utensils',         label: 'FSSAI Registration' },
  { icon: 'fa-ship',             label: 'Import Export Code (IEC)' },
  { icon: 'fa-certificate',      label: 'ISO Certification' },
  { icon: 'fa-file-contract',    label: 'Business Licenses' },
  { icon: 'fa-scale-balanced',   label: 'Regulatory Compliance' },
];

const values = [
  { icon: 'fa-handshake', title: 'Integrity',              color: '#6366f1', desc: 'Complete transparency and ethical practices in every engagement.' },
  { icon: 'fa-shield-halved', title: 'Reliability',        color: '#0ea5e9', desc: 'Committed to delivering accurate and timely services, always.' },
  { icon: 'fa-user-tie',  title: 'Client-Centric',         color: '#CFA047', desc: "Our clients' success is at the center of everything we do." },
  { icon: 'fa-star',      title: 'Excellence',             color: '#10b981', desc: 'Continuously striving for high-quality professional services.' },
];

const trusts = [
  { icon: 'fa-user-graduate',   label: 'Expert Guidance' },
  { icon: 'fa-location-dot',    label: 'PAN India Service Network' },
  { icon: 'fa-tags',            label: 'Transparent Pricing' },
  { icon: 'fa-headset',         label: 'Dedicated Support Team' },
  { icon: 'fa-file-lines',      label: 'Efficient Documentation' },
  { icon: 'fa-arrows-spin',     label: 'End-to-End Assistance' },
  { icon: 'fa-medal',           label: 'Commitment to Quality' },
];


/* ─── Main Component ─────────────────────────────────── */
const AboutPage = () => {
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);

  useEffect(() => {
    document.title = 'About Us | Legal Infos';
  }, []);

  /* scroll-reveal */
  useEffect(() => {
    const els = document.querySelectorAll('.ap-reveal');
    const io = new IntersectionObserver(
      (entries) => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('ap-revealed'); }),
      { threshold: 0.12 }
    );
    els.forEach(el => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Inter:wght@300;400;500;600;700&display=swap');

        /* ── Reset & Base ── */
        .ap-wrap { font-family: 'Inter', sans-serif; color: #1e293b; overflow-x: hidden; }

        /* ── Scroll Reveal ── */
        .ap-reveal { opacity: 0; transform: translateY(36px); transition: opacity 0.7s cubic-bezier(.22,1,.36,1), transform 0.7s cubic-bezier(.22,1,.36,1); }
        .ap-reveal.ap-delay-1 { transition-delay: 0.1s; }
        .ap-reveal.ap-delay-2 { transition-delay: 0.2s; }
        .ap-reveal.ap-delay-3 { transition-delay: 0.3s; }
        .ap-reveal.ap-delay-4 { transition-delay: 0.4s; }
        .ap-reveal.ap-delay-5 { transition-delay: 0.5s; }
        .ap-reveal.ap-delay-6 { transition-delay: 0.6s; }
        .ap-reveal.ap-delay-7 { transition-delay: 0.7s; }
        .ap-reveal.ap-revealed { opacity: 1; transform: none; }

        /* ════════════════════════════════════
           PAGE BANNER
        ════════════════════════════════════ */
        @keyframes apShimmer { to { background-position: 200% center; } }

        .ap-banner {
          position: relative;
          padding: 72px 24px 60px;
          background: linear-gradient(135deg, #061830 0%, #0a2040 60%, #0f2d50 100%);
          overflow: hidden;
          text-align: center;
        }
        .ap-banner::before {
          content: '';
          position: absolute;
          inset: 0;
          background:
            radial-gradient(ellipse 60% 80% at 80% 50%, rgba(207,160,71,0.14) 0%, transparent 60%),
            radial-gradient(ellipse 50% 60% at 10% 50%, rgba(99,102,241,0.12) 0%, transparent 55%);
          pointer-events: none;
        }
        .ap-banner-dots {
          position: absolute; inset: 0;
          background-image: radial-gradient(circle, rgba(255,255,255,0.05) 1px, transparent 1px);
          background-size: 36px 36px;
          pointer-events: none;
        }
        .ap-banner-inner {
          position: relative; z-index: 2;
          max-width: 760px; margin: 0 auto;
        }
        .ap-banner-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(207,160,71,0.12);
          border: 1px solid rgba(207,160,71,0.35);
          color: #e8c475; font-size: 11px;
          font-weight: 600; letter-spacing: 2.5px;
          text-transform: uppercase;
          padding: 7px 18px; border-radius: 40px;
          margin-bottom: 20px;
        }
        .ap-banner-title {
          font-family: 'Outfit', sans-serif;
          font-size: clamp(32px, 5vw, 52px);
          font-weight: 900;
          color: #fff;
          letter-spacing: -1.5px;
          line-height: 1.12;
          margin-bottom: 16px;
        }
        .ap-banner-title .ap-gold {
          background: linear-gradient(90deg, #CFA047 0%, #f0d080 50%, #CFA047 100%);
          background-size: 200% auto;
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: apShimmer 3s linear infinite;
        }
        .ap-banner-sub {
          font-size: 16px;
          color: rgba(255,255,255,0.62);
          line-height: 1.75;
          max-width: 600px;
          margin: 0 auto 24px;
        }
        .ap-banner-breadcrumb {
          display: flex; align-items: center; justify-content: center;
          gap: 8px; font-size: 13px;
          color: rgba(255,255,255,0.4);
        }
        .ap-banner-breadcrumb a { color: #CFA047; text-decoration: none; transition: opacity 0.2s; }
        .ap-banner-breadcrumb a:hover { opacity: 0.75; }

        /* ════════════════════════════════════
           STATS STRIP
        ════════════════════════════════════ */
        .ap-stats-strip {
          background: linear-gradient(135deg, #061830 0%, #0a2040 100%);
          padding: 0;
          position: relative;
          overflow: hidden;
        }
        .ap-stats-strip::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse at 50% 50%, rgba(207,160,71,0.1) 0%, transparent 70%);
        }
        .ap-stats-inner {
          position: relative;
          z-index: 2;
          max-width: 1100px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 0;
        }
        @media (max-width: 768px) { .ap-stats-inner { grid-template-columns: repeat(2,1fr); } }
        @media (max-width: 480px) { .ap-stats-inner { grid-template-columns: 1fr 1fr; } }

        .ap-stat-card {
          padding: 48px 24px;
          text-align: center;
          border-right: 1px solid rgba(255,255,255,0.06);
          position: relative;
          transition: background 0.3s;
        }
        .ap-stat-card:last-child { border-right: none; }
        .ap-stat-card::before {
          content: '';
          position: absolute;
          bottom: 0; left: 20%; right: 20%;
          height: 2px;
          background: linear-gradient(90deg, transparent, rgba(207,160,71,0.5), transparent);
          opacity: 0;
          transition: opacity 0.3s;
        }
        .ap-stat-card:hover::before { opacity: 1; }
        .ap-stat-card:hover { background: rgba(255,255,255,0.04); }
        .ap-stat-icon {
          width: 52px; height: 52px;
          border-radius: 14px;
          background: linear-gradient(135deg, rgba(207,160,71,0.2) 0%, rgba(207,160,71,0.08) 100%);
          border: 1px solid rgba(207,160,71,0.3);
          display: flex; align-items: center; justify-content: center;
          color: #CFA047;
          font-size: 20px;
          margin: 0 auto 16px;
          transition: transform 0.3s;
        }
        .ap-stat-card:hover .ap-stat-icon { transform: scale(1.12) rotate(-5deg); }
        .ap-stat-number {
          font-family: 'Outfit', sans-serif;
          font-size: clamp(32px, 4vw, 48px);
          font-weight: 900;
          color: #fff;
          letter-spacing: -1px;
          line-height: 1;
          margin-bottom: 8px;
          background: linear-gradient(90deg, #fff, #e8c475);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .ap-stat-label { font-size: 13px; color: rgba(255,255,255,0.5); font-weight: 500; letter-spacing: 0.5px; text-transform: uppercase; }

        /* ════════════════════════════════════
           SHARED SECTION WRAPPER
        ════════════════════════════════════ */
        .ap-section { max-width: 1100px; margin: 0 auto; padding: 100px 24px; }
        .ap-section-sm { max-width: 1100px; margin: 0 auto; padding: 80px 24px; }
        .ap-label {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 2.5px;
          text-transform: uppercase;
          color: #CFA047;
          margin-bottom: 16px;
        }
        .ap-label::before, .ap-label::after {
          content: '';
          display: inline-block;
          width: 20px; height: 2px;
          background: #CFA047;
          border-radius: 2px;
        }
        .ap-h2 {
          font-family: 'Outfit', sans-serif;
          font-size: clamp(30px, 4vw, 48px);
          font-weight: 800;
          color: #061830;
          letter-spacing: -1px;
          line-height: 1.15;
          margin-bottom: 20px;
        }
        .ap-h2 span { color: #CFA047; }
        .ap-lead { font-size: 17px; color: #64748b; line-height: 1.85; max-width: 640px; }
        .ap-para { font-size: 15.5px; color: #475569; line-height: 1.9; margin-bottom: 20px; }

        /* ════════════════════════════════════
           WHO WE ARE — two-column
        ════════════════════════════════════ */
        .ap-who { background: #fff; }
        .ap-who-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
        }
        @media (max-width: 900px) { .ap-who-grid { grid-template-columns: 1fr; gap: 48px; } }

        .ap-who-visual {
          position: relative;
          border-radius: 24px;
          overflow: visible;
        }
        .ap-who-img-box {
          background: linear-gradient(135deg, #061830 0%, #0f2d50 100%);
          border-radius: 24px;
          padding: 50px 40px;
          position: relative;
          overflow: hidden;
          min-height: 400px;
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
        }
        .ap-who-img-box::before {
          content: '';
          position: absolute;
          top: -30%; right: -20%;
          width: 300px; height: 300px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(207,160,71,0.25) 0%, transparent 65%);
        }
        .ap-who-img-box::after {
          content: '';
          position: absolute;
          inset: 0;
          background-image: radial-gradient(circle, rgba(255,255,255,0.04) 1px, transparent 1px);
          background-size: 28px 28px;
        }
        .ap-who-quote {
          position: relative;
          z-index: 2;
          font-family: 'Outfit', sans-serif;
          font-size: 22px;
          font-weight: 700;
          color: #fff;
          line-height: 1.45;
          margin-bottom: 20px;
        }
        .ap-who-quote::before {
          content: '\\201C';
          font-size: 80px;
          color: rgba(207,160,71,0.3);
          line-height: 0;
          position: absolute;
          top: 20px; left: -10px;
          font-family: Georgia, serif;
        }
        .ap-who-quote-attr {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .ap-who-quote-line { width: 32px; height: 2px; background: #CFA047; border-radius: 2px; }
        .ap-who-quote-name { font-size: 13px; color: rgba(255,255,255,0.6); font-weight: 500; letter-spacing: 0.5px; }

        /* Floating badge on visual */
        .ap-who-badge {
          position: absolute;
          top: -20px; right: -20px;
          background: #fff;
          border-radius: 16px;
          padding: 18px 20px;
          box-shadow: 0 12px 40px rgba(6,24,48,0.18);
          display: flex;
          align-items: center;
          gap: 12px;
          z-index: 5;
          border: 1px solid #f0f4f8;
        }
        .ap-who-badge-icon {
          width: 42px; height: 42px;
          border-radius: 12px;
          background: linear-gradient(135deg, #CFA047, #a67f35);
          display: flex; align-items: center; justify-content: center;
          color: #fff; font-size: 18px;
          flex-shrink: 0;
        }
        .ap-who-badge-val { font-family: 'Outfit', sans-serif; font-size: 22px; font-weight: 800; color: #061830; line-height: 1; }
        .ap-who-badge-lbl { font-size: 11px; color: #94a3b8; font-weight: 500; margin-top: 2px; }

        /* ════════════════════════════════════
           WHAT WE DO — service grid
        ════════════════════════════════════ */
        .ap-what { background: #f8fafc; }
        .ap-what-header { text-align: center; margin-bottom: 56px; }
        .ap-what-header .ap-lead { margin: 0 auto; }
        .ap-services-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
        }
        @media (max-width: 900px) { .ap-services-grid { grid-template-columns: repeat(2,1fr); } }
        @media (max-width: 500px) { .ap-services-grid { grid-template-columns: 1fr; } }

        .ap-svc-card {
          background: #fff;
          border-radius: 18px;
          border: 1px solid #e9eef5;
          padding: 28px 22px;
          text-align: center;
          cursor: default;
          transition: all 0.35s cubic-bezier(.22,1,.36,1);
          position: relative;
          overflow: hidden;
        }
        .ap-svc-card::before {
          content: '';
          position: absolute;
          bottom: 0; left: 0; right: 0;
          height: 3px;
          background: linear-gradient(90deg, #CFA047, #e8c475);
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.35s ease;
        }
        .ap-svc-card:hover { transform: translateY(-8px); box-shadow: 0 20px 50px rgba(6,24,48,0.1); border-color: transparent; }
        .ap-svc-card:hover::before { transform: scaleX(1); }
        .ap-svc-icon {
          width: 56px; height: 56px;
          border-radius: 16px;
          background: linear-gradient(135deg, rgba(207,160,71,0.12) 0%, rgba(207,160,71,0.06) 100%);
          border: 1px solid rgba(207,160,71,0.25);
          display: flex; align-items: center; justify-content: center;
          color: #CFA047;
          font-size: 22px;
          margin: 0 auto 16px;
          transition: all 0.35s cubic-bezier(.22,1,.36,1);
        }
        .ap-svc-card:hover .ap-svc-icon {
          background: linear-gradient(135deg, #CFA047 0%, #a67f35 100%);
          color: #fff;
          transform: scale(1.12) rotate(-8deg);
          border-color: transparent;
          box-shadow: 0 8px 24px rgba(207,160,71,0.4);
        }
        .ap-svc-label { font-size: 14px; font-weight: 600; color: #1e293b; line-height: 1.4; }

        /* ════════════════════════════════════
           MISSION & VISION
        ════════════════════════════════════ */
        .ap-mv { background: linear-gradient(160deg, #061830 0%, #0a2040 100%); position: relative; overflow: hidden; }
        .ap-mv::before {
          content: '';
          position: absolute;
          width: 700px; height: 700px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(207,160,71,0.1) 0%, transparent 65%);
          top: -200px; right: -100px;
          pointer-events: none;
        }
        .ap-mv::after {
          content: '';
          position: absolute;
          inset: 0;
          background-image: radial-gradient(circle, rgba(255,255,255,0.03) 1px, transparent 1px);
          background-size: 36px 36px;
          pointer-events: none;
        }
        .ap-mv .ap-h2 { color: #fff; }
        .ap-mv .ap-h2 span { color: #e8c475; }
        .ap-mv .ap-label { color: #e8c475; }
        .ap-mv .ap-label::before, .ap-mv .ap-label::after { background: #e8c475; }

        .ap-mv-cards {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 28px;
          margin-top: 56px;
        }
        @media (max-width: 700px) { .ap-mv-cards { grid-template-columns: 1fr; } }

        .ap-mv-card {
          background: rgba(255,255,255,0.04);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(255,255,255,0.1);
          border-radius: 24px;
          padding: 40px 36px;
          position: relative;
          overflow: hidden;
          transition: all 0.4s cubic-bezier(.22,1,.36,1);
        }
        .ap-mv-card:hover {
          background: rgba(255,255,255,0.07);
          border-color: rgba(207,160,71,0.3);
          transform: translateY(-6px);
          box-shadow: 0 24px 60px rgba(0,0,0,0.3);
        }
        .ap-mv-card-glow {
          position: absolute;
          width: 200px; height: 200px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(207,160,71,0.15) 0%, transparent 65%);
          top: -60px; right: -60px;
          pointer-events: none;
        }
        .ap-mv-card-icon {
          width: 60px; height: 60px;
          border-radius: 18px;
          background: linear-gradient(135deg, #CFA047 0%, #a67f35 100%);
          display: flex; align-items: center; justify-content: center;
          color: #fff; font-size: 24px;
          margin-bottom: 24px;
          box-shadow: 0 8px 24px rgba(207,160,71,0.4);
          position: relative;
          z-index: 1;
        }
        .ap-mv-card-title {
          font-family: 'Outfit', sans-serif;
          font-size: 24px; font-weight: 800;
          color: #fff; margin-bottom: 16px;
          position: relative; z-index: 1;
        }
        .ap-mv-card-text {
          font-size: 15px; color: rgba(255,255,255,0.65);
          line-height: 1.8; margin: 0;
          position: relative; z-index: 1;
        }

        /* ════════════════════════════════════
           VALUES
        ════════════════════════════════════ */
        .ap-vals { background: #fff; }
        .ap-vals-header { text-align: center; margin-bottom: 56px; }
        .ap-vals-header .ap-lead { margin: 0 auto; }
        .ap-vals-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 24px;
        }
        @media (max-width: 900px) { .ap-vals-grid { grid-template-columns: repeat(2,1fr); } }
        @media (max-width: 500px) { .ap-vals-grid { grid-template-columns: 1fr; } }

        .ap-val-card {
          border-radius: 22px;
          padding: 36px 28px;
          background: #f8fafc;
          border: 1px solid #e9eef5;
          transition: all 0.4s cubic-bezier(.22,1,.36,1);
          position: relative;
          overflow: hidden;
        }
        .ap-val-card-line {
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 3px;
          border-radius: 3px 3px 0 0;
        }
        .ap-val-card:hover { transform: translateY(-8px); box-shadow: 0 24px 60px rgba(6,24,48,0.1); background: #fff; border-color: transparent; }
        .ap-val-icon {
          width: 56px; height: 56px;
          border-radius: 16px;
          display: flex; align-items: center; justify-content: center;
          font-size: 22px; color: #fff;
          margin-bottom: 20px;
          box-shadow: 0 8px 20px rgba(0,0,0,0.15);
          transition: transform 0.35s cubic-bezier(.22,1,.36,1);
        }
        .ap-val-card:hover .ap-val-icon { transform: scale(1.12) rotate(-8deg); }
        .ap-val-title {
          font-family: 'Outfit', sans-serif;
          font-size: 19px; font-weight: 800;
          color: #061830; margin-bottom: 12px;
        }
        .ap-val-desc { font-size: 14px; color: #64748b; line-height: 1.75; margin: 0; }

        /* ════════════════════════════════════
           WHY TRUST US
        ════════════════════════════════════ */
        .ap-trust { background: #f8fafc; }
        .ap-trust-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: center;
        }
        @media (max-width: 900px) { .ap-trust-grid { grid-template-columns: 1fr; gap: 40px; } }

        .ap-trust-items {
          display: flex;
          flex-direction: column;
          gap: 18px;
          margin-top: 12px;
        }
        .ap-trust-item {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 18px 22px;
          background: #fff;
          border-radius: 14px;
          border: 1px solid #e9eef5;
          transition: all 0.3s cubic-bezier(.22,1,.36,1);
          cursor: default;
        }
        .ap-trust-item:hover {
          border-color: rgba(207,160,71,0.4);
          box-shadow: 0 8px 30px rgba(207,160,71,0.1);
          transform: translateX(6px);
        }
        .ap-trust-item-icon {
          width: 44px; height: 44px; flex-shrink: 0;
          border-radius: 12px;
          background: linear-gradient(135deg, rgba(207,160,71,0.15) 0%, rgba(207,160,71,0.08) 100%);
          border: 1px solid rgba(207,160,71,0.25);
          display: flex; align-items: center; justify-content: center;
          color: #CFA047; font-size: 17px;
          transition: all 0.3s;
        }
        .ap-trust-item:hover .ap-trust-item-icon {
          background: linear-gradient(135deg, #CFA047, #a67f35);
          color: #fff;
          border-color: transparent;
          box-shadow: 0 4px 16px rgba(207,160,71,0.4);
        }
        .ap-trust-item-label { font-size: 14.5px; font-weight: 600; color: #1e293b; }

        .ap-trust-visual {
          background: linear-gradient(135deg, #061830 0%, #0f2d50 100%);
          border-radius: 28px;
          padding: 50px 44px;
          position: relative;
          overflow: hidden;
        }
        .ap-trust-visual::before {
          content: '';
          position: absolute;
          top: -30%; right: -20%;
          width: 300px; height: 300px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(207,160,71,0.2) 0%, transparent 65%);
        }
        .ap-trust-visual-title {
          font-family: 'Outfit', sans-serif;
          font-size: 26px; font-weight: 800;
          color: #fff; margin-bottom: 12px;
          position: relative; z-index: 1;
        }
        .ap-trust-visual-sub {
          font-size: 14px; color: rgba(255,255,255,0.6);
          line-height: 1.7; margin-bottom: 30px;
          position: relative; z-index: 1;
        }
        .ap-trust-chips { display: flex; flex-wrap: wrap; gap: 10px; position: relative; z-index: 1; }
        .ap-trust-chip {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: rgba(255,255,255,0.07);
          border: 1px solid rgba(255,255,255,0.12);
          color: rgba(255,255,255,0.85);
          font-size: 12.5px;
          font-weight: 500;
          padding: 8px 14px;
          border-radius: 50px;
          backdrop-filter: blur(8px);
          transition: all 0.3s;
        }
        .ap-trust-chip:hover {
          background: rgba(207,160,71,0.2);
          border-color: rgba(207,160,71,0.4);
          color: #e8c475;
        }
        .ap-trust-chip i { font-size: 11px; color: #CFA047; }

        /* ════════════════════════════════════
           FINAL CTA
        ════════════════════════════════════ */
        .ap-cta {
          position: relative;
          padding: 120px 24px;
          text-align: center;
          overflow: hidden;
          background: #040e1e;
        }
        .ap-cta-mesh {
          position: absolute;
          inset: 0;
          background:
            radial-gradient(ellipse 70% 70% at 20% 50%, rgba(99,102,241,0.2) 0%, transparent 60%),
            radial-gradient(ellipse 60% 60% at 80% 50%, rgba(207,160,71,0.18) 0%, transparent 55%),
            linear-gradient(160deg, #040e1e 0%, #061830 100%);
        }
        .ap-cta-dots {
          position: absolute; inset: 0;
          background-image: radial-gradient(circle, rgba(255,255,255,0.05) 1px, transparent 1px);
          background-size: 36px 36px;
        }
        .ap-cta-content { position: relative; z-index: 2; max-width: 720px; margin: 0 auto; }
        .ap-cta-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(207,160,71,0.12);
          border: 1px solid rgba(207,160,71,0.35);
          color: #e8c475; font-size: 11.5px;
          font-weight: 600; letter-spacing: 2px;
          text-transform: uppercase;
          padding: 7px 18px; border-radius: 40px;
          margin-bottom: 28px;
        }
        .ap-cta-title {
          font-family: 'Outfit', sans-serif;
          font-size: clamp(32px, 5vw, 56px);
          font-weight: 900; color: #fff;
          letter-spacing: -1.5px; line-height: 1.1;
          margin-bottom: 20px;
        }
        .ap-cta-title .ap-gold {
          background: linear-gradient(90deg, #CFA047 0%, #f0d080 50%, #CFA047 100%);
          background-size: 200% auto;
          -webkit-background-clip: text; -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: apShimmer 3s linear infinite;
        }
        .ap-cta-sub { font-size: 16px; color: rgba(255,255,255,0.65); margin-bottom: 44px; line-height: 1.75; }
        .ap-cta-actions { display: flex; align-items: center; justify-content: center; gap: 16px; flex-wrap: wrap; }
        .ap-cta-btn {
          display: inline-flex; align-items: center; gap: 10px;
          padding: 16px 38px;
          background: linear-gradient(135deg, #CFA047 0%, #a67f35 100%);
          color: #fff; font-size: 15px; font-weight: 700;
          border-radius: 50px; text-decoration: none;
          transition: all 0.3s cubic-bezier(.22,1,.36,1);
          box-shadow: 0 6px 28px rgba(207,160,71,0.45);
        }
        .ap-cta-btn:hover {
          transform: translateY(-3px) scale(1.04);
          box-shadow: 0 12px 40px rgba(207,160,71,0.6);
          color: #fff;
        }
        .ap-cta-btn-outline {
          display: inline-flex; align-items: center; gap: 10px;
          padding: 15px 34px;
          border: 1.5px solid rgba(255,255,255,0.25);
          color: rgba(255,255,255,0.85);
          font-size: 15px; font-weight: 600;
          border-radius: 50px; text-decoration: none;
          backdrop-filter: blur(8px);
          transition: all 0.3s;
        }
        .ap-cta-btn-outline:hover { border-color: rgba(207,160,71,0.6); color: #e8c475; background: rgba(207,160,71,0.08); }
      `}</style>

      <TopBar />
      <Navbar />

      <div className="ap-wrap">

        {/* ─── PAGE BANNER ─── */}
        <div className="ap-banner">
          <div className="ap-banner-dots"></div>
          <div className="ap-banner-inner">
            <div className="ap-banner-badge">
              <i className="fa-solid fa-building-columns"></i>
              About Us
            </div>
            <h1 className="ap-banner-title">
              Empowering Businesses Through <span className="ap-gold">Simplified Compliance</span>
            </h1>
            <p className="ap-banner-sub">
              A professional consultancy dedicated to helping entrepreneurs, startups, SMEs, and established organizations navigate India's regulatory landscape with confidence.
            </p>
            <div className="ap-banner-breadcrumb">
              <Link to="/">Home</Link>
              <i className="fa-solid fa-chevron-right" style={{ fontSize: '9px' }}></i>
              <span>About Us</span>
            </div>
          </div>
        </div>


        {/* ─── WHO WE ARE ─── */}
        <div className="ap-who">
          <div className="ap-section">
            <div className="ap-who-grid">
              <div className="ap-reveal">
                <div className="ap-who-visual">
                  <div className="ap-who-img-box">
                    <div className="ap-who-quote">
                      Making legal and compliance services accessible, affordable, and hassle-free for every Indian business.
                    </div>
                    <div className="ap-who-quote-attr">
                      <div className="ap-who-quote-line"></div>
                      <div className="ap-who-quote-name">Legal Infos — Founded with a Vision</div>
                    </div>
                  </div>
                  {/* <div className="ap-who-badge">
                    <div className="ap-who-badge-icon"><i className="fa-solid fa-award"></i></div>
                    <div>
                      <div className="ap-who-badge-val">10+ Yrs</div>
                      <div className="ap-who-badge-lbl">Trusted Expertise</div>
                    </div>
                  </div> */}
                </div>
              </div>

              <div>
                <div className="ap-reveal ap-delay-1">
                  <div className="ap-label">Who We Are</div>
                  <h2 className="ap-h2">India's Trusted <span>Compliance</span> Partner</h2>
                </div>
                <div className="ap-reveal ap-delay-2">
                  <p className="ap-para">Legal Infos is a professional business registration and compliance consultancy dedicated to helping entrepreneurs, startups, SMEs, and established organizations navigate India's regulatory landscape with confidence.</p>
                  <p className="ap-para">Founded with the vision of making legal and compliance services accessible, affordable, and hassle-free, we provide comprehensive support for business registrations, licenses, certifications, and regulatory requirements across India.</p>
                  <p className="ap-para">Our team works closely with clients to understand their business objectives and deliver customized solutions that ensure compliance while supporting growth.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ─── WHAT WE DO ─── */}
        <div className="ap-what">
          <div className="ap-section">
            <div className="ap-what-header ap-reveal">
              <div className="ap-label">Our Services</div>
              <h2 className="ap-h2">What We <span>Do</span></h2>
              <p className="ap-lead">We offer a wide range of business and legal compliance services to help you start, grow, and operate with confidence.</p>
            </div>
            <div className="ap-services-grid">
              {services.map((s, i) => (
                <div key={i} className={`ap-svc-card ap-reveal ap-delay-${Math.min(i % 4 + 1, 7)}`}>
                  <div className="ap-svc-icon"><i className={`fa-solid ${s.icon}`}></i></div>
                  <div className="ap-svc-label">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ─── MISSION & VISION ─── */}
        <div className="ap-mv">
          <div className="ap-section">
            <div className="ap-reveal" style={{ textAlign: 'center', marginBottom: '8px' }}>
              <div className="ap-label" style={{ justifyContent: 'center' }}>Our Purpose</div>
              <h2 className="ap-h2" style={{ textAlign: 'center', color: '#fff' }}>Mission <span style={{ color: '#e8c475' }}>&</span> Vision</h2>
            </div>
            <div className="ap-mv-cards">
              <div className="ap-mv-card ap-reveal ap-delay-1">
                <div className="ap-mv-card-glow"></div>
                <div className="ap-mv-card-icon"><i className="fa-solid fa-bullseye"></i></div>
                <div className="ap-mv-card-title">Our Mission</div>
                <p className="ap-mv-card-text">To simplify business compliance and provide reliable, transparent, and professional services that help businesses start, operate, and grow successfully.</p>
              </div>
              <div className="ap-mv-card ap-reveal ap-delay-2">
                <div className="ap-mv-card-glow"></div>
                <div className="ap-mv-card-icon"><i className="fa-solid fa-eye"></i></div>
                <div className="ap-mv-card-title">Our Vision</div>
                <p className="ap-mv-card-text">To become one of India's most trusted compliance and business registration service providers by delivering exceptional customer experience and professional excellence.</p>
              </div>
            </div>
          </div>
        </div>

        {/* ─── VALUES ─── */}
        <div className="ap-vals">
          <div className="ap-section">
            <div className="ap-vals-header ap-reveal">
              <div className="ap-label">What We Stand For</div>
              <h2 className="ap-h2">Our Core <span>Values</span></h2>
              <p className="ap-lead">The principles that guide every decision we make and every service we deliver.</p>
            </div>
            <div className="ap-vals-grid">
              {values.map((v, i) => (
                <div key={i} className={`ap-val-card ap-reveal ap-delay-${i + 1}`}>
                  <div className="ap-val-card-line" style={{ background: `linear-gradient(90deg, ${v.color}, ${v.color}99)` }}></div>
                  <div className="ap-val-icon" style={{ background: `linear-gradient(135deg, ${v.color} 0%, ${v.color}bb 100%)`, boxShadow: `0 8px 20px ${v.color}40` }}>
                    <i className={`fa-solid ${v.icon}`}></i>
                  </div>
                  <div className="ap-val-title">{v.title}</div>
                  <p className="ap-val-desc">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ─── WHY TRUST US ─── */}
        <div className="ap-trust">
          <div className="ap-section">
            <div className="ap-trust-grid">
              <div>
                <div className="ap-reveal">
                  <div className="ap-label">Why Choose Us</div>
                  <h2 className="ap-h2">Why Businesses <span>Trust</span> Legal Infos</h2>
                  <p className="ap-lead" style={{ marginBottom: '0' }}>Every business deserves a compliance partner who goes above and beyond. Here's what sets us apart.</p>
                </div>
                <div className="ap-trust-items">
                  {trusts.map((t, i) => (
                    <div key={i} className={`ap-trust-item ap-reveal ap-delay-${Math.min(i + 1, 7)}`}>
                      <div className="ap-trust-item-icon"><i className={`fa-solid ${t.icon}`}></i></div>
                      <div className="ap-trust-item-label">{t.label}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="ap-reveal ap-delay-2">
                <div className="ap-trust-visual">
                  <div className="ap-trust-visual-title">Your Success is Our Mission</div>
                  <div className="ap-trust-visual-sub">
                    At Legal Infos, we believe every successful business begins with a strong legal and compliance foundation. Our mission is to help entrepreneurs and organizations build that foundation with confidence and peace of mind.<br /><br />
                    Whether you are starting a new business or expanding an existing one, Legal Infos is your trusted compliance partner every step of the way.
                  </div>
                  <div className="ap-trust-chips">
                    {['PAN India', 'ISO Certified', 'Expert CAs', 'Transparent', 'End-to-End', '24/7 Support', 'Secure Data'].map((c, i) => (
                      <span key={i} className="ap-trust-chip">
                        <i className="fa-solid fa-check"></i> {c}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ─── FINAL CTA ─── */}
        <div className="ap-cta">
          <div className="ap-cta-mesh"></div>
          <div className="ap-cta-dots"></div>
          <div className="ap-orb ap-orb-1" style={{ opacity: 0.4 }}></div>
          <div className="ap-orb ap-orb-2" style={{ opacity: 0.3 }}></div>
          <div className="ap-cta-content ap-reveal">
            <div className="ap-cta-badge"><i className="fa-solid fa-handshake"></i> Your Trusted Partner</div>
            <h2 className="ap-cta-title">Ready to Build Your Business<br/>on a <span className="ap-gold">Solid Foundation?</span></h2>
            <p className="ap-cta-sub">Whether you are starting a new business or expanding an existing one, Legal Infos is your trusted compliance partner every step of the way.</p>
            <div className="ap-cta-actions">
              <Link to="/#services" className="ap-cta-btn">
                Get Started Today <i className="fa-solid fa-arrow-right"></i>
              </Link>
              <button onClick={() => setIsConsultationOpen(true)} className="ap-cta-btn-outline" style={{ background: 'transparent', cursor: 'pointer' }}>
                <i className="fa-solid fa-phone"></i> Contact Us
              </button>
            </div>
          </div>
        </div>

      </div>

      <Footer />
      <ConsultationModal 
        isOpen={isConsultationOpen} 
        onClose={() => setIsConsultationOpen(false)} 
      />
    </>
  );
};

export default AboutPage;
